export enum B2bMarketPriceUploadStatusEnum {
  UNKNOWN = "unknown",
  PENDING = "pending",
  PROCESSED = "processed",
}
